import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import BatchStatus from '../models/BatchStatus';
import Checkbox from '@material-ui/core/Checkbox';
import QADetails from './QADetails';

//Icons
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
//files import
import CheckedAndApproved from '../models/checkedAndApproved';
import { useStyles } from './styles';
import ViewSupplierPO from './ViewSupplierPO';
import StatusManager from '../grnReceipts/StatusManager';
// import EditSupplierPO from './EditSupplierPO';
import DownloadSupplierPO from './DownloadSupplierPO';

import CustomTableCell from '../../common/models/table/CustomTableCell';
import {
  presentFormatedData,
  presentDate,
} from '../functionalComponents/dataFormatFunctions';
// import InTransitRightIcon from './InTransitRightIcon';

function ExpandableAsnRow(props) {
  const [open, setOpen] = useState(false);
  // const { POLineRecordDetails, GRDetails } = props.row;
  const classes = useStyles();
  const [selected, setSelected] = React.useState([]);
  const { collabType } = localStorage;
  const { row, grnFeatures } = props;
  const [rowData, setRowData] = React.useState(null);

  let scheduleDateFlag = useSelector(
    (state) =>
      state.pcmp.common.reports.rmpmGrnFeatures?.data.features
        .scheduledDeliveryDate
  );

  const handleSelectAllClick = (event) => {
    const newSelecteds = [];
    rowData.asnPOLists.map((n) =>
      n.GRDetails.map((m) => {
        newSelecteds.push(m.schrockenSupplierPOBatchID);
      })
    );
    if (event.target.checked) {
      setSelected(newSelecteds);
      newSelecteds.map((n) => {
        const data = {
          [n]: event.target.checked,
        };
        return props.selectedArrayValue(data);
      });
      return;
    } else if (event.target.checked === false) {
      setSelected([]);
      const dataArray = [];
      newSelecteds.map((n) => {
        return dataArray.push({ [n]: event.target.checked });
      });
      props.selectedArrayValue(dataArray);
      return;
    } else {
      setSelected([]);
      props.selectedArrayValue([]);
    }
  };

  const handleClick = (event, name) => {
    if (event.target.checked === true) {
      const data = {
        [name]: event.target.checked,
      };
      setSelected([...selected, name]);
      props.selectedArrayValue(data);
    } else if (!event.target.checked) {
      const data = { [name]: event.target.checked };
      setSelected(selected.filter((n) => n !== name));
      props.selectedArrayValue(data);
    }
  };

  const isSelected = (name) => {
    if (props.selected.indexOf(name.toString()) === -1) {
      return false;
    } else if (props.selected.indexOf(name.toString()) !== -1) {
      return true;
    }
  };

  const getLength = () => {
    let length = 0;

    rowData.asnPOLists.forEach((n) => {
      n.GRDetails.forEach((m) => {
        length += 1;
      });
    });
    return length;
  };

  React.useEffect(() => {
    if (rowData?.asnPOLists) {
      const newSelecteds = [];
      rowData.asnPOLists.map((n) =>
        n.GRDetails.map((m) => {
          newSelecteds.push(m.schrockenSupplierPOBatchID);
        })
      );
      let arr = [];
      newSelecteds.forEach((element) => {
        if (props.selected.indexOf(element.toString()) !== -1) {
          arr.push(element.toString());
        }
      });
      setSelected(arr);
    }
  }, [props.selected, rowData]);

  useEffect(() => {
    if (row && Array.isArray(row.asnPOLists) && row.asnPOLists.length > 0) {
      const handleASN = (element, newRow) => {
        if (Array.isArray(element?.GRDetails) && element.GRDetails.length > 1) {
          let po = {
            POLineRecordDetails: element.POLineRecordDetails,
          };

          element.GRDetails.forEach((batch) => {
            newRow.asnPOLists.push({
              ...po,
              GRDetails: [batch],
            });
          });
        } else {
          newRow.asnPOLists.push(element);
        }
      };

      const process = async () => {
        let newRow = {
          asnNumber: row.asnNumber,
          asnPOLists: [],
        };

        for (let element of row.asnPOLists) {
          handleASN(element, newRow);
        }

        setRowData(newRow);
      };

      process();
    }
  }, [row]);

  return (
    <React.Fragment>
      {rowData ? (
        <>
          <TableRow
            className={classes.root}
            key={rowData.asnNumber}
            style={{
              backgroundColor: props.keys % 2 === 0 ? '#FFF' : '#0000000a',
            }}
          >
            <TableCell
              size='small'
              style={{
                width: '1%',
                maxWidth: '0.2rem',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              <IconButton
                aria-label='expand row'
                size='small'
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </TableCell>
            <TableCell
              padding='checkbox'
              style={{
                width: '1%',
                maxWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              <Checkbox
                checked={
                  rowData.asnPOLists.length > 0 &&
                  selected.length == getLength()
                }
                indeterminate={
                  selected.length > 0 && selected.length < getLength()
                }
                onChange={(event) => handleSelectAllClick(event)}
                inputProps={{
                  'aria-labelledby': `enhanced-table-checkbox-${rowData.asnNumber}`,
                }}
              />
            </TableCell>
            <CustomTableCell align='left'>
              {presentFormatedData(rowData.asnNumber, '-')}
            </CustomTableCell>
            <CustomTableCell scope='row' align='left'></CustomTableCell>
            <CustomTableCell align='left'></CustomTableCell>
            {scheduleDateFlag && <CustomTableCell />}
            {/** Table cell to skip sch. del date */}
            <CustomTableCell></CustomTableCell>
            <CustomTableCell hideCell></CustomTableCell>
            <CustomTableCell
              align='left'
              elementStyle={{ maxWidth: '0px' }}
            ></CustomTableCell>
            <CustomTableCell align='left'></CustomTableCell>
            <CustomTableCell align='right' hideCell></CustomTableCell>
            <CustomTableCell
              align='right'
              //  hideCell
            ></CustomTableCell>
            <CustomTableCell align='right'></CustomTableCell>
            <CustomTableCell align='left' hideCell></CustomTableCell>
            <CustomTableCell hideCell align='left'>
              -
            </CustomTableCell>
            <CustomTableCell hideCell align='center'>
              -
            </CustomTableCell>
            <CustomTableCell align='left'></CustomTableCell>
            <CustomTableCell align='center'>-</CustomTableCell>
            <CustomTableCell
              className={classes.changingWidth}
              align='left'
            ></CustomTableCell>
          </TableRow>
          {open === true &&
            rowData.asnPOLists.map((row, i) => {
              const isItemSelected = isSelected(
                row.GRDetails[0].schrockenSupplierPOBatchID
              );
              const labelId = `enhanced-table-checkbox-${row.GRDetails[0].schrockenSupplierPOBatchID}`;
              return (
                <TableRow
                  key={row.GRDetails[0].schrockenSupplierPOBatchID}
                  style={{
                    backgroundColor:
                      props.keys % 2 === 0 ? '#FFF' : '#0000000a',
                  }}
                >
                  <TableCell
                    style={{
                      width: '1%',
                      maxWidth: '0.2rem',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <IconButton />
                  </TableCell>
                  <TableCell
                    onClick={(event) =>
                      handleClick(
                        event,
                        row.GRDetails[0].schrockenSupplierPOBatchID
                      )
                    }
                    padding='checkbox'
                    aria-checked={isItemSelected}
                    style={{
                      width: '1%',
                      maxWidth: 0,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <Checkbox
                      checked={isItemSelected}
                      inputProps={{ 'aria-labelledby': labelId }}
                    />
                  </TableCell>
                  <CustomTableCell align='left'>
                    {presentFormatedData(row.GRDetails[0].asnNumber, '-')}
                  </CustomTableCell>
                  <CustomTableCell scope='row' align='left'>
                    {row.POLineRecordDetails.supplierPurchaseOrderNumber}
                  </CustomTableCell>
                  <CustomTableCell align='left'>
                    {presentFormatedData(
                      row.GRDetails[0].analyticalReportNumber,
                      '-'
                    )}
                  </CustomTableCell>
                  {scheduleDateFlag && (
                    <CustomTableCell>
                      {presentDate(
                        row.POLineRecordDetails.scheduledDeliveryDate
                      )}
                    </CustomTableCell>
                  )}
                  <CustomTableCell
                    align={
                      row.GRDetails[0].materialReceivedDate === null
                        ? 'center'
                        : 'left'
                    }
                  >
                    {presentDate(row.GRDetails[0].materialReceivedDate)}
                  </CustomTableCell>
                  {/* </div> */}
                  <CustomTableCell key='hide' align='left' hideCell>
                    {/* {presentFormatedData(POLineRecordDetails.materialType)} */}
                    {presentFormatedData(
                      row.POLineRecordDetails.materialType === 'ROH'
                        ? 'RM'
                        : row.POLineRecordDetails.materialType === 'VERP'
                        ? 'PM'
                        : row.POLineRecordDetails.materialType
                    )}
                  </CustomTableCell>

                  <CustomTableCell
                    align='left'
                    elementStyle={{ maxWidth: '0px' }}
                  >
                    {row.POLineRecordDetails.materialCode}/
                    <br />
                    {row.POLineRecordDetails.materialName}
                  </CustomTableCell>
                  <CustomTableCell align='left'>
                    {presentFormatedData(
                      row.POLineRecordDetails.unitOfMeasurementOrdered
                    )}
                  </CustomTableCell>
                  <CustomTableCell align='right' hideCell>
                    {presentFormatedData(
                      row.POLineRecordDetails.quantityOrdered
                    )}
                  </CustomTableCell>
                  <CustomTableCell
                    align='right'
                    // hideCell
                  >
                    {row.GRDetails[0].actualQuantityReceived}
                  </CustomTableCell>
                  <CustomTableCell align='right'>
                    {row.GRDetails[0].quantityYetToReceive}
                  </CustomTableCell>
                  <CustomTableCell align='left' hideCell>
                    {presentFormatedData(row.POLineRecordDetails.supplierName)}
                  </CustomTableCell>
                  <CustomTableCell align='left' hideCell>
                    {row.GRDetails[0].approvedBy === null ||
                    row.GRDetails[0].approvedBy === '' ||
                    row.GRDetails[0].approvedBy === undefined ? (
                      row.GRDetails[0].rejectedBy === null ||
                      row.GRDetails[0].rejectedBy === '' ||
                      row.GRDetails[0].rejectedBy === undefined ? (
                        '-'
                      ) : (
                        <CheckedAndApproved
                          name={row.GRDetails[0].rejectedBy}
                        />
                      )
                    ) : (
                      <CheckedAndApproved name={row.GRDetails[0].approvedBy} />
                    )}
                  </CustomTableCell>
                  <CustomTableCell hideCell>
                    {presentFormatedData(row.GRDetails[0].numberMRN)}
                  </CustomTableCell>
                  <CustomTableCell align='left'>
                    {BatchStatus(row.GRDetails[0].batchStatusID)}
                  </CustomTableCell>
                  <CustomTableCell>
                    {presentFormatedData(row.GRDetails[0].numberGRN)}
                  </CustomTableCell>
                  <CustomTableCell
                    className={classes.changingWidth}
                    align='left'
                  >
                    <div className={classes.actions}>
                      <div>
                        {row.POLineRecordDetails.statusID === 9 ||
                        row.POLineRecordDetails.statusID === 10 ||
                        // row.POLineRecordDetails.statusID === 11 ||
                        row.POLineRecordDetails.statusID === 18
                          ? null
                          : StatusManager(
                              row.GRDetails[0].batchStatusID,
                              row.POLineRecordDetails,
                              row.GRDetails[0],
                              grnFeatures
                            )}
                        {/* {null} */}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {/* {collabType !== 'Pharma Co' &&
                      grnFeatures.editGrRecord === true &&
                      POLineRecordDetails.statusID !== 9 &&
                      POLineRecordDetails.statusID !== 10 &&
                      POLineRecordDetails.statusID !== 11 &&
                      (row.batchStatusID === 2 || row.batchStatusID === 4) && (
                        <EditSupplierPO
                          POLineRecordDetails={POLineRecordDetails}
                          row={row}
                          status={row.batchStatusID}
                          saveRecord={true}
                        />
                      )} */}
                        {grnFeatures.viewGrRecord === true && (
                          <ViewSupplierPO
                            supplierPurchaseOrderNumber={
                              row.POLineRecordDetails
                                .supplierPurchaseOrderNumber
                            }
                            materialCode={row.POLineRecordDetails.materialCode}
                            schrockenSupplierPOBatchID={
                              row.GRDetails[0].schrockenSupplierPOBatchID
                            }
                            listBy={props.listBy}
                          />
                        )}
                        {collabType !== 'Pharma Co' &&
                          grnFeatures.updateGrRecord === true &&
                          [9, 10, 18].includes(
                            row.POLineRecordDetails.statusID
                          ) === false &&
                          row.GRDetails[0].batchStatusID === 6 && (
                            <QADetails
                              POLineRecordDetails={row.POLineRecordDetails}
                              row={row.GRDetails[0]}
                              status={row.GRDetails[0].batchStatusID}
                              saveRecord={true}
                            />
                          )}

                        {row.GRDetails[0].batchStatusID !== 1 &&
                          grnFeatures.bulkDownloadGrFiles === true && (
                            <DownloadSupplierPO
                              schrockenSupplierPOBatchID={
                                row.GRDetails[0].schrockenSupplierPOBatchID
                              }
                              supplierPurchaseOrderNumber={
                                row.POLineRecordDetails
                                  .supplierPurchaseOrderNumber
                              }
                            />
                          )}
                      </div>
                    </div>
                  </CustomTableCell>
                </TableRow>
              );
            })}
        </>
      ) : null}
    </React.Fragment>
  );
}

export default ExpandableAsnRow;
